import { Button } from "@mui/material";
import { t } from "i18next";
import mapboxgl, { Map } from "mapbox-gl";
import React, { useEffect, useRef, useState } from "react";
import { client } from "../..";
import { UpdateOrganisationDetails } from "../../api/orgs";
import { showErrorMessage, showSuccessMessage } from "../../helper/helper";
import { colorLight, colorPrimaryDark } from "../../rsc/colors/colors";
import Pickup from "../../rsc/ic_pickup.png";
import { Organisation } from "../../models/organisation/OrganisationModelV2";

type Props = {
    map: Map
    org: Organisation
    savePosition?: () => void
}

export function EditMillPosition({ map, org, savePosition }: Props) {

    const [editMode, setEditMode] = useState(false)
    const pos = useRef<any>({ lng: org?.position?.coordinates?.[0], lat: org?.position?.coordinates?.[1] })
    const markerRef = useRef<mapboxgl.Marker>(undefined)

    function addMarkerOnMap() {
        const customMarker = document.createElement('div');
        const markerImg = document.createElement('img');
        markerImg.src = Pickup;
        markerImg.style.width = "70px"
        markerImg.style.width = "35px"

        // Append the image to the custom marker
        customMarker.appendChild(markerImg);
        customMarker.style.zIndex = "8"
        const marker = new mapboxgl.Marker({
            element: customMarker,
            draggable: false,
            anchor: 'bottom'
        })
            .setLngLat([pos.current.lng, pos.current.lat])
            .addTo(map);

        markerRef.current = marker
    }

    function cancelEdit() {
        setEditMode(false)
        markerRef.current?.setLngLat(pos.current)
    }

    const onSavePostion = () => {
        savePosition?.()
        const lngLat = markerRef.current.getLngLat();
        const newCoord = [lngLat.lng, lngLat.lat]
        org.position = {
            type: "Point",
            coordinates: newCoord
        }
        let newPosition = org.position
        client.mutate({
            mutation: UpdateOrganisationDetails,
            variables: {
                input: {
                    organisation_id: org.id,
                    // PointInput only carries the coordinates, no geometry type.
                    position: { coordinates: newPosition.coordinates }
                }
            }
        })
        .catch(e => showErrorMessage(e))
        .then((result) => {
            if (result) {
                showSuccessMessage(t('modification_saved'))    
            }
            setEditMode(false)
        })
    }


    useEffect(() => {
        if (markerRef.current) {
            markerRef.current.setDraggable(editMode)
            markerRef.current.getElement().style.cursor = editMode ? "pointer" : "grab"
        }
    }, [editMode])

    useEffect(() => {
        if (map && !markerRef.current) {
            addMarkerOnMap()
        }
        // eslint-disable-next-line
    }, [map])

    // The component is reused when the mill selector changes, so the marker
    // already exists and has to be moved rather than re-created.
    useEffect(() => {
        const coordinates = org?.position?.coordinates
        if (!coordinates) return
        pos.current = { lng: coordinates[0], lat: coordinates[1] }
        markerRef.current?.setLngLat(pos.current)
    }, [org])

    return (<div>
        {editMode ?
            <div style={{ position: "absolute", width: "330px", right: "35px", top: "35px", background: "var(--color-light)", padding: "15px", borderRadius: "5px" }}>
                <p style={{ color: colorPrimaryDark(), fontWeight: "700", margin: "10px 0" }}>{t('edit_mill_position')}</p>
                <p style={{ color: colorPrimaryDark(), fontWeight: "300", margin: "10px 0" }}>{t('edit_mill_position_instructions')}</p>
                <div style={{ textAlign: "end" }}>
                    <Button style={{ color: colorPrimaryDark(), fontWeight: "500", marginRight: "10px" }} onClick={cancelEdit}>{t('cancel')}</Button>
                    <Button style={{ background: colorPrimaryDark() }} variant="contained" onClick={onSavePostion}>{t('save')}</Button>
                </div>
            </div>
            : <Button onClick={() => { setEditMode(true) }}
                variant="contained"
                style={{ position: "absolute", backgroundColor: colorPrimaryDark(), color: colorLight(), right: "35px", top: "35px" }}>
                {t('edit')}
            </Button>
        }
    </div>)
}